module.exports = __webpack_public_path__ + "img/c02_unitsiegetower_Normal_ua.1c4d87b0.webp";